import UserProfile from '../../base/pages/userProfile';

const userProfile: UserProfile = {
  requestFailed: "Úprava profilu se nezdařila."
};

export default userProfile;
